import { useContext } from 'react'
import ErrorContext, { SuccessContext } from '../ErrorContext'
import { OrgAppContext } from '../OrgAppContext'
import { ApiReturnType } from './apiPost'

export function useApiGet(apiCall: (data?: any) => Promise<ApiReturnType>) {
  const { setIsError } = useContext(ErrorContext)
  const { customerId, orgId, appId } = useContext(OrgAppContext)
  return async (body?: any) => {
    setIsError(false)
    const { error, data } = await apiCall({ ...body, customerId, orgId, appId })
    if (error) {
      setIsError(true)
      return null
    }
    return data
  }
}

export function useApiPost(apiCall: (data?: any) => Promise<ApiReturnType>) {
  const { setIsError } = useContext(ErrorContext)
  const { setIsSuccess } = useContext(SuccessContext)
  const { customerId, orgId, appId } = useContext(OrgAppContext)
  return async (body?: any) => {
    setIsError(false)
    const { error } = await apiCall({ ...body, customerId, orgId, appId })
    if (error) {
      setIsError(true)
      return error
    }
    setIsSuccess(true)
    return null
  }
}
